<template>
    <div style="width: 100%; height: 500px; text-align: center; line-height: 500px; font-weight: bold; font-size: 100px;">
        404
        <span style="font-size: 50px"> 页面不存在</span>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
}
</script>

